import { gql } from "@apollo/client";
import { getClient } from "lib/apolloClient";
import type { GracePeriodEntitlement } from "@shared/graphql.types";

export const GRACE_PERIOD_CONFIG_QUERY = gql`
  query getGracePeriodEntitlement {
    getGracePeriodEntitlement {
      expiresAt
      willBeGrantedGift
      subscriptionId
    }
  }
`;

export const getGracePeriodEntitlement =
  async (): Promise<GracePeriodEntitlement> => {
    const client = getClient();

    const response = await client.query<{
      getGracePeriodEntitlement: GracePeriodEntitlement;
    }>({
      query: GRACE_PERIOD_CONFIG_QUERY,
      fetchPolicy: "cache-first",
      context: {
        sessionStrategy: "REDIRECT_TO_LOGIN"
      }
    });

    return response.data.getGracePeriodEntitlement;
  };
